export default __webpack_public_path__ + "static/media/faq.b57f774d.png";